// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2mMas","container":"styles_container__2zKiz","title":"styles_title__2Mi8C","wrapper":"styles_wrapper__2pW9h","answer":"styles_answer__3RhPr"};